export const VISIT_TYPES = [
  'Initial Consultation',
  'Follow-up',
  'Urgent Care',
  'Medication Review',
  'Lab Review',
  'Mental Health',
  'Other',
];

/** Patient-facing label and description for each visit medium, used on the booking page selector. */
export const VISIT_MEDIUM_OPTIONS: Array<{ value: 'video' | 'phone' | 'sms'; label: string; description: string }> = [
  {
    value: 'video',
    label: 'Video Visit',
    description: 'See and talk with your provider over secure video. Best for face-to-face conversations. Needs a camera, microphone, and a stable internet connection.',
  },
  {
    value: 'phone',
    label: 'Phone Call',
    description: 'Talk with your provider by audio only. You\'ll dial a number and enter a PIN at your appointment time. Good when video isn\'t convenient.',
  },
  {
    value: 'sms',
    label: 'Text Message',
    description: 'Chat with your provider over SMS text messages. Great for quick questions or follow-ups. A mobile phone number is required.',
  },
];

export const SCHED_DAYS = [
  { key: 'mon', label: 'Mon' },
  { key: 'tue', label: 'Tue' },
  { key: 'wed', label: 'Wed' },
  { key: 'thu', label: 'Thu' },
  { key: 'fri', label: 'Fri' },
  { key: 'sat', label: 'Sat' },
  { key: 'sun', label: 'Sun' },
] as const;

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri'];

/** Full verbal consent script for patient-facing SMS opt-in (Twilio toll-free verification requirement). */
export const SMS_CONSENT_SCRIPT_PATIENT =
  'By checking this box, you consent to receive SMS text messages from SimplyTelehealth on behalf of your healthcare provider, including appointment reminders and visit notifications. Message frequency varies. Message and data rates may apply. You can opt out at any time by replying STOP to any message. View our SMS Consent Policy at simplytelehealth.md/sms-consent and Privacy Policy at simplytelehealth.md/privacy.';

/** Full verbal consent script for provider-facing SMS opt-in. */
export const SMS_CONSENT_SCRIPT_PROVIDER =
  'By checking this box, you consent to receive SMS text messages from SimplyTelehealth, including visit reminders and notifications. Message frequency varies. Message and data rates may apply. You can opt out at any time by replying STOP to any message. View our SMS Consent Policy at simplytelehealth.md/sms-consent and Privacy Policy at simplytelehealth.md/privacy.';

/** Verbal consent script for providers to read aloud when attesting patient consent. */
export const SMS_CONSENT_SCRIPT_VERBAL =
  'Do you agree to receive text message reminders about your upcoming telehealth appointments from SimplyTelehealth on behalf of your healthcare provider? Message and data rates may apply. You can opt out at any time by replying STOP.';
